import { Button } from "@/components/ui/button";
import { ArrowRight, Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import MarqueeSection from "@/components/MarqueeSection";
import { openCalendly } from "@/lib/calendly";

const HeroSection = () => {
  const { language, setLanguage, t } = useLanguage();
  return <>
      {/* Hero Banner - Image only with CTA */}
      <section id="home" className="h-screen flex flex-col bg-gradient-hero relative overflow-hidden" style={{ contain: 'layout' }}>
        {/* Background hero video */}
        <div className="absolute inset-0">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            preload="metadata"
            className="w-full h-full object-cover will-change-auto"
            style={{ objectFit: 'cover', contain: 'strict' }}
          >
            <source src="/hero-video.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        {/* Logo and Language Toggle at top */}
        <div className="absolute top-0 left-0 right-0 z-20 px-4 sm:px-6 lg:px-8 pt-2 pb-4">
          <div className="flex justify-between items-center">
            <img 
              src="/lovable-uploads/50355940-4071-4f39-8046-9727ab73dae8.png" 
              alt="MindSite AI" 
              width="160"
              height="80"
              // @ts-ignore
              fetchpriority="high"
              className="h-16 sm:h-20 w-auto brightness-0 invert"
            />
            <Button
              variant="outline"
              size="sm"
              onClick={() => setLanguage(language === 'en' ? 'sk' : 'en')}
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border-white/20 text-white hover:bg-white/20"
            >
              <Globe className="h-4 w-4" />
              {language.toUpperCase()}
            </Button>
          </div>
        </div>

        {/* Marquee positioned at bottom to cover text */}
        <div className="absolute bottom-0 left-0 right-0 z-30">
          <MarqueeSection />
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col h-full">
          {/* Title at top */}
          <div className="pt-32 text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-4 sm:mb-6 px-2 sm:px-4 leading-tight uppercase" style={{ fontWeight: 900 }}>
              <span className="block text-white font-display">
                {t('hero.title')}
              </span>
              <span className="block mt-2 text-white font-outline" style={{ fontWeight: 800 }}>
                {t('hero.titleHighlight')}
              </span>
            </h1>
          </div>

          {/* CTA Button in center */}
          <div className="flex-1 flex items-center justify-center pb-24">
            <div className="max-w-4xl mx-auto text-center">
            {/* CTA Button */}
            <Button onClick={() => document.getElementById('website-types')?.scrollIntoView({ behavior: 'smooth' })} size="lg" className="bg-white hover:bg-accent text-accent hover:text-white text-base sm:text-lg px-6 sm:px-8 py-4 sm:py-6 rounded-full shadow-accent group w-full sm:w-auto transition-all will-change-transform">
              {t('hero.startWebsite')}
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 transition-transform group-hover:translate-x-1" />
            </Button>
            </div>
          </div>
        </div>
      </section>
    </>;
};
export default HeroSection;